import { Observable } from 'rxjs';

export abstract class GtmRepository {
    abstract setDataLayer<T extends object>(dataLayer: T): Observable<boolean>;
    abstract reserveSearch(): Observable<boolean>;
    abstract viewItemList(): Observable<boolean>;
    abstract selectItem(): Observable<boolean>;
    abstract addToCart(): Observable<boolean>;
    abstract beginCheckout(): Observable<boolean>;
    abstract purchase(reservationCode: string): Observable<boolean>;
    abstract refund(reservationCode: string): Observable<boolean>;
    abstract selectCart(): Observable<boolean>;
    abstract selectExtras(): Observable<boolean>;
    abstract reservationComplete(id: string): Observable<boolean>;
}
